module.exports = __webpack_public_path__ + "img/header-24.e8eaeef.jpeg";